module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hans/1-03a52bfcd8c41a13d3455f1e15d9accc.jpg";